// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"37a06f2e","609":"8a73899a","809":"8caf3855","873":"80ed0256","955":"c429bb5d"}[chunkId] + ".chunk.js";
};